import { FlowTask } from "@/controllers/flow";

/**
 * SP専用の表示/戻る動線を提供するタスク群。
 */

/**
 * SP画面のメイン領域を表示状態にするタスク（opacity操作）。
 */
export class SPShowScreenTask extends FlowTask {
  async flowProcess(done) {
    const gameMainContainer = document.querySelector(".play-main");
    gameMainContainer.style.opacity = 1;
    done();
  }
}

/**
 * 戻るボタンの挙動を提供するタスク。
 * - history があれば history.back
 * - なければ data-back-url へ遷移
 */
export class SPBackTask extends FlowTask {
  constructor() {
    super();
    this.backButtonElement = document.querySelector("#game-back-button");
    this.backUrl = this.backButtonElement.dataset.backUrl;
  }

  // eslint-disable-next-line no-unused-vars
  async flowProcess(done) {
    this.onBack = () => {
      if (history.length > 1) {
        history.back();
      } else {
        window.location.href = this.backUrl;
      }
    };

    this.backButtonElement.addEventListener("click", this.onBack);
  }

  deinitialize() {
    this.backButtonElement.removeEventListener("click", this.onBack);
  }
}
